import React, { useEffect, useMemo, useState } from "react";
import HRHeader from "../components/HRHeader";
import api from "../api";
import { Mail, Phone, Search, Building2, BookUser } from "lucide-react";

const ROLE_LABEL = { admin: "Amministratore HR", responsabile: "Responsabile", dipendente: "Dipendente" };

const RubricaPage = () => {
  const [people, setPeople] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/directory").then((r) => setPeople(r.data)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return people;
    return people.filter((p) =>
      [p.name, p.email, p.dept, p.job_title, p.matricola].some((f) => (f || "").toLowerCase().includes(s))
    );
  }, [q, people]);

  const initials = (name) => (name || "?").split(" ").map((s) => s[0]).slice(0, 2).join("").toUpperCase();

  return (
    <div className="min-h-screen bg-[#f0f2f5]" data-testid="rubrica-page">
      <HRHeader />
      <main className="max-w-[1200px] mx-auto px-4 py-8">
        <h1 className="text-[26px] font-black text-[#16345c] mb-1 flex items-center gap-2"><BookUser size={24} /> Rubrica Aziendale</h1>
        <p className="text-[14px] text-gray-500 mb-6">Contatti dei colleghi del gruppo.</p>

        <div className="relative max-w-md mb-6">
          <Search size={17} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input value={q} onChange={(e) => setQ(e.target.value)} data-testid="rubrica-search" placeholder="Cerca per nome, reparto, ruolo..." className="w-full border border-gray-300 rounded-sm pl-9 pr-3 py-2.5 text-[14px] outline-none focus:border-[#16345c]" />
        </div>

        <div className="text-[13px] text-gray-500 mb-3">{filtered.length} colleghi</div>
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4" data-testid="rubrica-grid">
          {filtered.map((p) => (
            <div key={p.id} className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
              <div className="flex items-center gap-3 mb-3">
                <span className="w-12 h-12 rounded-full bg-[#16345c] text-white flex items-center justify-center text-[15px] font-bold shrink-0">{initials(p.name)}</span>
                <div className="min-w-0">
                  <div className="text-[15px] font-bold text-[#16345c] truncate">{p.name}</div>
                  <div className="text-[12.5px] text-gray-500 truncate">{p.job_title}</div>
                </div>
              </div>
              <div className="space-y-1.5 text-[13px]">
                <div className="flex items-center gap-2 text-gray-600"><Building2 size={14} className="text-gray-400 shrink-0" /> <span className="truncate">{p.dept}</span> <span className="text-[10px] font-bold uppercase text-gray-400">· {ROLE_LABEL[p.role]}</span></div>
                <a href={`mailto:${p.email}`} className="flex items-center gap-2 text-[#0d6cb8] hover:underline"><Mail size={14} className="shrink-0" /> <span className="truncate">{p.email}</span></a>
                {p.phone && <div className="flex items-center gap-2 text-gray-600"><Phone size={14} className="text-gray-400 shrink-0" /> {p.phone}</div>}
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default RubricaPage;
